import { render, staticRenderFns } from "./HomeTecnico.vue?vue&type=template&id=5ca409e4&scoped=true"
import script from "./HomeTecnico.vue?vue&type=script&lang=js"
export * from "./HomeTecnico.vue?vue&type=script&lang=js"
import style0 from "./HomeTecnico.vue?vue&type=style&index=0&id=5ca409e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca409e4",
  null
  
)

export default component.exports